import * as api from "@/api";
import LocalStorage from "@/classes/local-storage";
import * as signals from "@/signals";
import { BookmarkResponse } from "@/types";
import {
	keepPreviousData,
	useQuery,
	UseQueryResult,
} from "@tanstack/react-query";

function useShortcuts(): UseQueryResult<BookmarkResponse | undefined> {
	let presets = LocalStorage.getPresetShortcutTitles();

	return useQuery({
		initialData: () => ({
			children: LocalStorage.getShortcuts() || presets,
			dockItems: LocalStorage.getDockItems() || presets,
		}),
		placeholderData: keepPreviousData,
		queryFn: () => {
			if (!signals.login.value.username) {
				presets = LocalStorage.getPresetShortcutTitles();
				return {
					children: presets,
					dockItems: presets,
				};
			}
			return api.getAllBookmarks();
		},
		queryKey: ["bookmarks", signals.login.value.username],
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		retry: false,
	});
}

export default useShortcuts;
